import React, { useState, useEffect } from 'react'

import PaymentTicket from './PaymentTicket';
import Invoices from './Invoices'

import { Modals } from './styles'

const ModalsList = ({ paymentTicket, setPaymentTicket, invoice, setInvoice }) => {

  useEffect(() => {
    if (paymentTicket) setPaymentTicket(paymentTicket);
    if (invoice) setInvoice(invoice);
  }, [paymentTicket, invoice]);

  return (
    <Modals>
      {paymentTicket && <PaymentTicket paymentTicket={paymentTicket} setPaymentTicket={setPaymentTicket} />}
      {invoice && <Invoices invoice={invoice} setInvoice={setInvoice} />}
    </Modals>
  );
};

export default ModalsList;
